import { useEffect } from "react";
import { Form } from "antd";
import dayjs from "dayjs";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";

const ReportInformation = ({ report = {} }) => {
  const [form] = Form.useForm();

  useEffect(() => {
   const reportDateTime =
      report.dateReported && report.timeReported
        ? dayjs(`${report.dateReported} ${report.timeReported}`, "MM/DD/YYYY HH:mm")
        : null;
    const dateTimeOccurred =
      report.dateOccurred && report.timeOccurred
        ? dayjs(`${report.dateOccurred} ${report.timeOccurred}`, "MM/DD/YYYY HH:mm")
        : null;

    form.setFields([
      { name: "reportedBy", value: report.reportedBy || "" },
      { name: "reportDateTime", value: reportDateTime },
      { name: "enteredBy", value: report.enteredBy || "" },
      { name: "bookingNumber", value: report.bookingID || "" },
      { name: "caseNumber", value: report.caseNumber || "" },
      { name: "dateTimeOccurred", value: dateTimeOccurred },
      { name: "shift", value: report.shift || "" },
      { name: "reportType", value: report.reportType || "" },
    ]);
  }, [report, form]);

  return (
    <Form form={form} layout="vertical">
      <StyledGridRow gutter={16} justify={'start'}>
        <StyledGridCol lg={12}>
          <FormItem label="Reporting Officer" name="reportedBy">
            <Select
              options={getOptionsFromRefList("", true, false, true)}
              placeholder="Select Officer"
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem label="Report Date/Time" name="reportDateTime">
            <CommonDatePicker />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem label="Entered By" name="enteredBy">
            <Select
              options={getOptionsFromRefList("", true, false, true)}
              placeholder="Select Entered By"
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol>
          <FormItem label="Booking #" name="bookingID">
            <h3 style={{ margin: "0" }}>
              {report.bookingID || ""}
            </h3>
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={4}>
          <FormItem label="Case Number" name="caseNumber">
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem label="Date/Time Occurred" name="dateTimeOccurred">
            <CommonDatePicker />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={5}>
          <FormItem label="Shift" name="shift">
            <Select
              options={getOptionsFromRefList("Shift", false, false, true)}
              placeholder="Select Shift"
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem label="Type of Report" name="reportType">
            <Select
              options={getOptionsFromRefList("Charges_reportTypes", false, false, true)}
              placeholder="Select Report Type"
            />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
};

export default ReportInformation;
